// Share links: a one-file program travels in the page's URL fragment,
// compressed, so sharing needs no server and the program never reaches one
// (browsers do not send the fragment).
//
//   #title=<name>&mode=extended&code=<source>
//
// where source is the program's UTF-8 text, deflated (raw) and in unpadded
// base64url.

const toBase64Url = (bytes) => {
  let binary = "";
  for (let k = 0; k < bytes.length; k += 0x8000) binary += String.fromCharCode(...bytes.subarray(k, k + 0x8000));
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const fromBase64Url = (text) => {
  const binary = atob(text.replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = new Uint8Array(binary.length);
  for (let k = 0; k < binary.length; ++k) bytes[k] = binary.charCodeAt(k);
  return bytes;
};

const transform = async (bytes, stream) =>
  new Uint8Array(await new Response(new Blob([bytes]).stream().pipeThrough(stream)).arrayBuffer());

export async function encodeShare({ title, mode, source }) {
  const compressed = await transform(new TextEncoder().encode(source), new CompressionStream("deflate-raw"));
  const params = new URLSearchParams({ title, mode: "extended" });
  return `${params}&code=${toBase64Url(compressed)}`;
}

// The program a fragment holds, or null when it holds none.
export async function decodeShare(fragment) {
  const params = new URLSearchParams(fragment.replace(/^#/, ""));
  const code = params.get("code");
  if (!code) return null;
  const bytes = await transform(fromBase64Url(code), new DecompressionStream("deflate-raw"));
  return {
    title: params.get("title") || "Shared",
    mode: "extended",
    source: new TextDecoder().decode(bytes),
  };
}
